import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import ArrowButton from "../common/ArrowButton";
import { assetUrl, ensureThemeJsonArray, getStoredUser, themeColors } from "../../functions/themeAssets";
import "../common/saveThem.css";

export default function Rules() {
  const navigate = useNavigate();
  const { status, data: themeData } = useSelector((state) => state.theme);
  const user = getStoredUser();

  useEffect(() => {
    if (!user) {
      navigate("/login", { replace: true });
    } else if (Number(user.gameover ?? 0) > 0) {
      Swal.fire({
        title: "Already Played",
        text: "You have already played this game.",
        icon: "info",
        confirmButtonText: "OK",
      }).then(() => {
        window.location.href = user.backButtonRedirect || process.env.REACT_APP_BASE_URL || "/";
      });
    }
  }, [user, navigate]);

  if (!user) return null;

  if (!themeData || status === "loading") {
    return (
      <div className="st-loader">
        <div className="st-loader-spinner" />
      </div>
    );
  }

  const { box, text } = themeColors(themeData);
  const rules = ensureThemeJsonArray(themeData.rules);

  return (
    <div className="st-rules">
      {themeData.logo && <img src={assetUrl(themeData.logo)} className="st-rules-logo" alt="" />}
      <div className="st-rules-card">
        <h3 className="st-rules-title" style={{ background: box, color: text }}>
          Rules
        </h3>
        <ul className="st-rule-list" style={{ color: text }}>
          {rules.map((rule, i) => (
            <li key={i}>{rule}</li>
          ))}
        </ul>
      </div>
      <ArrowButton to="/game" label="Next" box={box} text={text} />
    </div>
  );
}
